
<template>
    <ListDialog ref="ChargeJournalDialog" :title="$parent.formatTitle('諸掛元帳')" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="onReportGenerate" :isRemainAfterExec="true" >
      <template slot="header" slot-scope = "{editor}">
	      <AutoComplete title="帳票テンプレート" :editor="editor" :value.sync="reportTemplate" :required="true" query="ChargeJournalReportTemplateQuery" tooltip="出力する帳票のテンプレートを選択します。【帳票テンプレート】の【帳票タイプ】が【諸掛元帳】のデータを選択でき、初期値は×で消してから変更が可能です。" />
        <AtcSegment title="部門" :editor="editor" :value.sync="segment" tooltip="ここで部門を選択をすると、選択した部門だけのデータを出力する事ができます。選択しない場合はすべての部門のデータが出力できます。" />
        <AtcCounterpart title="取引先" :value.sync="counterpart" :editor="editor" :needsSupplier="true" :needsCustomer="true" tooltip="ここで取引先を選択をすると、選択した取引先だけのデータを出力する事ができます。選択しない場合はすべての取引先のデータが出力できます。" />
	      <Calendar title="発生日(From)" :editor="editor" :value.sync="bookDateFrom" :deletable="false" :required="true" :autoEntry="true" :dateFlag.sync="bookDateFromFlag" tooltip="データを帳票に出力をする発生日の開始日を指定します。ここで指定した日付以前のデータは出力対象外となります。" />
	      <Calendar title="発生日(To)" :editor="editor" :value.sync="bookDateTo" :deletable="false" :required="true" :autoEntry="true" :dateFlag.sync="bookDateToFlag"  tooltip="データを帳票に出力をする発生日の終了日を指定します。ここで指定した日付以降のデータは出力対象外となります。" />
        <RadioButton title="出力形式" :editor="editor" :value.sync="onExcelExport" list="reportStyles"/>             
        </template>
        <button slot="footer_buttons" type="button" class="btn btn-info" :disabled="$parent.favoriteDisabled" @click="$parent.onShowFavorite">{{$parent.favoriteLoaded? 'お気に入りを更新':'お気に入りに追加'}}</button>
        <button slot="footer_buttons" type="button" class="btn btn-secondary btn_delete" :disabled="$parent.favoriteDisabled" @click="$parent.onDeleteFavorite" v-if="$parent.favoriteLoaded"><i class="material-symbols-outlined small valign">delete</i></button>               
      </ListDialog> 
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptCargeJournal extends Vue {

  // 出荷予定表用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  public segment: Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public bookDateFrom: Date = null;
  public bookDateTo: Date = null;
  public onExcelExport :boolean = false;
  public bookDateFromFlag : Common.dateFlags = Common.dateFlags.default;
  public bookDateToFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
    if ((this.$parent as any).favoriteLoaded == false){    
      var query: Common.ChargeJournalReportTemplateQuery = new Common.ChargeJournalReportTemplateQuery();
      this.$api.execute(query).then(obj => {
        var items: Common.ReportTemplate[] = new Array();
        items = (obj as Common.LoadResult).result;
        if (items.length > 0) this.reportTemplate = items[0];
      });
    }
    this.bookDateFrom = new Date().getCalendarDate();
    this.bookDateFrom.setDate(1);
    this.bookDateTo = new Date().getCalendarDate();
    this.bookDateTo.setMonth(this.bookDateFrom.getMonth() + 1);
    this.bookDateTo.setDate(0);

    (this.$refs.ChargeJournalDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.ChargeJournalReportQuery = new Common.ChargeJournalReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.segment = this.segment;
    query.counterpart = this.counterpart;
    query.bookDateFrom = this.bookDateFrom;
    query.bookDateTo = this.bookDateTo;
    query.onExcelExport = this.onExcelExport;    
   this.$api.download(query);
  }
}
</script>
